import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { TopologyData } from './types';

const KEY = ['ref-topology-parameters'];

export function useTopology() {
    return useQuery({ queryKey: KEY, queryFn: async () => (await (await fetch('/api/ref-topology-parameters')).json()) as TopologyData });
}

export function useUpdatePipe() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ id, dn }: { id: string; dn: number }) =>
            (await (
                await fetch(`/api/ref-topology-parameters/pipes/${id}`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ dn }),
                })
            ).json()) as TopologyData,
        onSuccess: (data) => qc.setQueryData(KEY, data),
    });
}
